import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { logoRegistry } from './SitesNav.config';
let SitesNav = class SitesNav extends Vue {
    getGrayscaleLogoSrc(siteName) {
        var _a, _b;
        return (_b = (_a = logoRegistry[siteName]) === null || _a === void 0 ? void 0 : _a.grayscale) !== null && _b !== void 0 ? _b : '';
    }
    getColorLogoSrc(siteName) {
        var _a, _b;
        return (_b = (_a = logoRegistry[siteName]) === null || _a === void 0 ? void 0 : _a.default) !== null && _b !== void 0 ? _b : '';
    }
};
__decorate([
    Prop({ type: Array, required: true })
], SitesNav.prototype, "links", void 0);
SitesNav = __decorate([
    Component({
        name: 'SitesNav'
    })
], SitesNav);
export { SitesNav };
export default SitesNav;
